import { http } from '@/core/api/';
import qs from 'querystring';

const apiUrl = 'api/sysparameter';
const codeBaseURL = 'api/code';

export const getAcademicYears = () => {
  return http.get('api/academicyears/sysparametersacademicyears');
};

export const getCurrentAcademiYear = () => {
  return http.get('api/academicyears/current');
};

export const getPagedData = (
  academiYearID,
  searchString,
  pageSize,
  currentPage
) => {
  let queryString = `academiYearID=${academiYearID}`;
  queryString += `&searchString=${searchString}`;
  queryString += `&pageSize=${pageSize}`;
  queryString += `&currentPage=${currentPage}`;

  return http.get(`${apiUrl}/parameterssearch?${queryString}`);
};

export const getTypeCodes = () => {
  return http.get(`${codeBaseURL}/getcodebytype?type=SysParameterType`);
};

export const getAcademicDifficultyProgress = () => {
  return http.get(`${codeBaseURL}/getacademicdifficultyprogress`);
};

export const getDataTypeCodes = () => {
  return http.get(`${codeBaseURL}/getcodebytype?type=SysParameterDataType`);
};

export const getSubNameCodes = () => {
  return http.get(`${codeBaseURL}/getcodebytype?type=SysParameterSubName`);
};

export const getNameCodes = () => {
  return http.get(`${codeBaseURL}/getcodebytype?type=SysParameterName`);
};

export const getSysParamById = (id) => {
  return http.get(`${apiUrl}/sysparameter?sysParameterId=${id}`);
};

export const saveSysParam = (data) => {
  return http.post(`${apiUrl}/create`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateSysParam = (data) => {
  return http.put(`${apiUrl}/update`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteSysParam = (id) => {
  return http.delete(`${apiUrl}/delete/${id}`);
};

export const getSysparameterByNames = async (params) => {
  return await http.get(`${apiUrl}/byparameternames`, {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  });
};

export const getSysparameterByNameAndAcademicYear = async (
  paratemerName,
  academicYear
) => {
  return await http.get(`${apiUrl}/byparameternameandacademicyear`, {
    params: {
      parameterName: paratemerName,
      academicYear,
    },
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  });
};

export const generateParametersAndConfForFutureYear = async () => {
  return await http.get(`${apiUrl}/generateparametersanddataforfutureyear`);
};
